import { IStudyResolved } from "@syntensor/common/types";

function mapToName(data: string[]): Record<string, any> {
  return data.map((str) => {
    try {
      return JSON.parse(str);
    } catch (error) {
      return {
        name: str,
      };
    }
  });
}

// this seems to translate between ES and the AI data structure
export function getTemplateFromStudyData(templateStudy: IStudyResolved) {
  const {
    displayName,
    description,
    type,
    cellLines,
    compounds,
    componentTypes,
    targetExternalComponents,
    targetExternalPathways,
    endpoints,
  } = templateStudy;

  // [JSON.stringify({"name":"tedt","id":"erger"})]

  const cellLine = cellLines && cellLines.length ? cellLines[0].id : "";
  const targetExternalComponentIds = mapToName(targetExternalComponents ?? []);
  const targetExternalPathwayIds = mapToName(targetExternalPathways ?? []);

  //  convert endpoints to an array used in the frontend
  const formattedEndpoints = endpoints
    ? Object.keys(endpoints).map((endpointName) => {
        return {
          name: endpointName,
          ...endpoints[endpointName],
        };
      })
    : null;

  return {
    displayName,
    description,
    type,
    cellLine,
    compounds,
    targetExternalComponents: targetExternalComponentIds,
    targetExternalPathways: targetExternalPathwayIds,
    componentTypes,
    endpoints: formattedEndpoints,
  };
}
